import { EstateDetails } from '@contexts/Estate/Shared';
import { AdministrationPrice } from '../models/types/administration-price.type';
import { EstateApplicationInfo } from '../models/types/estate-application-info.type';
import { EstateId } from '../models/types/estate-id.type';
import { Price } from '../models/types/price.type';
import { option } from 'fp-ts';
import { UserId } from '../models/types';
import { pipe } from 'fp-ts/lib/function';
import { AuthenticatedUser } from '@shared/Authentication';

export type InitUnderwritingAsTenantCommand = {
  estateInfo: EstateApplicationInfo;
  tenant: {
    id: number;
    name?: string;
    phone?: string;
  };
};

export namespace InitUnderwritingAsTenantCommand {
  type Args = {
    estate: EstateDetails;
    tenant: AuthenticatedUser;
  };

  export const from = ({
    estate,
    tenant,
  }: Args): InitUnderwritingAsTenantCommand => ({
    estateInfo: {
      estateId: EstateId.of(estate.id),
      rentalPrice: Price.of(estate.price),
      admonPrice: AdministrationPrice.of(estate.administrationPrice),
      broker: pipe(option.fromNullable(estate.broker), option.map(UserId.of)),
    },
    tenant: {
      id: tenant.id!,
      name:
        tenant.firstName && !tenant.firstName.toLowerCase().includes('unknown')
          ? `${tenant.firstName} ${tenant.lastName}`
          : undefined,
      phone: tenant.phoneNumber,
    },
  });
}
